module.exports = __webpack_public_path__ + "img/avatar.bc2e9175.svg";